import { Container, Row, Col, Spinner, Button, Form } from 'react-bootstrap'
import { StepHeader } from '../StepHeader/StepHeader'
import { StepperComponent } from '../../Components/StepperComponent/StepperComponent'
import { useNavigate, useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useLocalStorage } from '../../Hooks/useLocalStorage'
import './Step3.scss'
import config from '../../config'

export const Step3 = () => {
  const navigate = useNavigate()
  const { state } = useLocation()
  const [loading, setLoading] = useState(true)
  const [mondayWorkspaces, setMondayWorkspaces] = useState({
    filteredWorkspaces: [],
    allWorkspaces: [],
  })
  const [selectedWorkspace, setSelectedWorkspace] = useLocalStorage('selectedWorkspace', '')
  const [workspaceIsSelected, setWorkspaceIsSelected] = useState(false)
  const mondayApiKey =
    'eyJhbGciOiJIUzI1NiJ9.eyJ0aWQiOjMxNTE4MzMxMSwiYWFpIjoxMSwidWlkIjo0NzMyMTg4MiwiaWFkIjoiMjAyNC0wMS0yOVQxMzo1ODo0NS4wMDBaIiwicGVyIjoibWU6d3JpdGUiLCJhY3RpZCI6MTA2NTE1MjUsInJnbiI6InVzZTEifQ.i3GpNnTvOaQ6MxeUUJG2afPtHh0PSoPPKLiL8dJLb6w'

  useEffect(() => {
    const update = async () => {
      const getWorkspacesFromMonday = await fetch(
        `${config.BACKEND_URL}/monday/listMondayWorkspaces`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'ngrok-skip-browser-warning': '69420',
          },
          body: JSON.stringify({
            mondayApiKey: mondayApiKey,
          }),
          credentials: 'include',
        },
      )
      const workspacesData = await getWorkspacesFromMonday.json()
      setMondayWorkspaces({
        filteredWorkspaces: workspacesData.workspaces,
        allWorkspaces: workspacesData.workspaces,
      })
      await new Promise((resolve) => setTimeout(() => resolve(), 4000))
      setLoading(false)
    }
    update()
  }, [])

  const handleSearchInput = (e) => {
    const value = e.target.value
    if (value) {
      const filteredWorkspacesList = mondayWorkspaces.allWorkspaces.filter((workspace) =>
        workspace.name.toLowerCase().includes(value.toLowerCase()),
      )
      setMondayWorkspaces((prevState) => ({
        ...prevState,
        filteredWorkspaces: filteredWorkspacesList,
      }))
    }
  }

  if (loading) {
    return (
      <Container>
        <Row>
          <StepHeader />
        </Row>
        <Row>
          <Col>
            <StepperComponent currentStep={3} />
          </Col>
        </Row>
        <Row className="d-flex align-items-center justify-content-center">
          <Spinner animation="grow" variant="dark" />
        </Row>
      </Container>
    )
  }

  return (
    <Container>
      <Row>
        <StepHeader />
      </Row>
      <Row>
        <Col>
          <StepperComponent currentStep={3} />
        </Col>
      </Row>

      {/* {WORKSPACE PICKER AREA} */}
      <Row className={'d-flex mb-3 justify-content-center'}>
        <Col md={2}></Col>
        <Col md={8}>
          <Form.Control
            placeholder="Search for a Workspace"
            type="text"
            onChange={handleSearchInput}
          />
        </Col>
      </Row>
      <Row className={'d-flex mb-3 justify-content-center'}>
        <Col md={2} className={'align-self-flex-start mt-2'}>
          <div>{'Choose a workspace'}</div>
        </Col>
        <Col md={8}>
          <div className={'workspace-picker'}>
            {mondayWorkspaces.filteredWorkspaces.map((workspace) => (
              <ul
                id={workspace.id}
                key={workspace.id}
                style={{
                  cursor: 'pointer',
                  padding: '6px 8px',
                  margin: '2px 0',
                  backgroundColor: workspace === selectedWorkspace ? '#e6e6e6' : 'white',
                }}
                onClick={() => {
                  setSelectedWorkspace(workspace)
                  setWorkspaceIsSelected(true)
                }}
              >
                {workspace.name}
              </ul>
            ))}
          </div>
        </Col>
      </Row>

      {/* {Button Area} */}
      <Row className={'mt-5'}>
        <Col xs={11} className={'d-flex justify-content-end'}>
          <Button
            className={'me-5'}
            onClick={() => {
              navigate('/step2')
            }}
          >
            Back
          </Button>
          <Button
            disabled={!workspaceIsSelected}
            onClick={() => {
              navigate('/step4')
            }}
          >
            Next
          </Button>
        </Col>
      </Row>
    </Container>
  )
}
